import { fetchAuthSession } from 'aws-amplify/auth';
import axios from 'axios';
import config from './config';

// Get the current user's Cognito ID token
export async function getIdToken() {
    const { tokens } = await fetchAuthSession();
    return tokens.idToken.toString();
}

// Fetch attended + artist caught/missed status for a single event
export async function fetchEventStatus(eventId) {
    const token = await getIdToken();
    const res = await axios.get(`${config.API_URL}/user/event/${eventId}`, {
        headers: { Authorization: token }
    });
    return res.data; // { attended, artist_status, event_id }
}

// Toggle attended for an event, returns { attended, event_id }
export async function toggleAttended(eventId) {
    const token = await getIdToken();
    const res = await axios.post(`${config.API_URL}/user/attended`, { event_id: eventId }, {
        headers: { Authorization: token }
    });
    return res.data;
}

// Toggle caught/missed for an artist at an event, returns { caught, event_id, artist_id }
export async function toggleCaught(eventId, artistId) {
    const token = await getIdToken();
    const res = await axios.post(`${config.API_URL}/user/caught`, { event_id: eventId, artist_id: artistId }, {
        headers: { Authorization: token }
    });
    return res.data;
}
